import React from "react";
import EngineerAdmin from "@/pages/EngineerAdmin";

/**
 * FIELD-001C1A · Shell-free administration content component.
 *
 * `EngineerAdmin` supports two rendering modes via the `shell` prop:
 *   * `"installer"` — wraps content in `<InstallerShell>` (legacy
 *                     `/settings/engineers` behaviour);
 *   * `"operations"` — expects the parent page to provide the shell.
 *
 * This wrapper is the SINGLE ENTRYPOINT the Operations Field Team
 * Management page uses to mount the admin form. Isolating it in its
 * own module makes the intent obvious in reviews and keeps a stable
 * import surface for focused tests
 * (`FieldTeamAdminContent.field001c1a.test.jsx`).
 *
 * IMPORTANT: We MUST pass `shell="operations"` — anything else re-
 * introduces the nested `<InstallerShell>` bug fixed in FIELD-001C1A.
 */
export default function FieldTeamAdminContent(props) {
    return (
        <EngineerAdmin
            {...props}
            shell="operations"
            hideHeader
            mode="identity"
            eyebrow={props.eyebrow ?? "Operations · Field Team Management"}
            backFallback={props.backFallback ?? "/operations/administration"}
            variant={props.variant ?? "administration"}
            canManage={props.canManage ?? true}
            title={props.title ?? "Field Team"}
        />
    );
}
